export type FileType = 'fotos' | 'videos' | 'audios' | 'lives';

export interface StorageFile {
  id: number;
  name: string;
  type: FileType;
  sizeMB: number;
  sizeDisplay: string;
  uploadedAt: string;
  dimensions?: string;
  duration?: string;
  isPesado: boolean;
}

export const fileTypeLabels: Record<FileType, string> = {
  fotos: 'Fotos',
  videos: 'Videos',
  audios: 'Audios',
  lives: 'Lives',
};

export const fileTypeIcons: Record<FileType, string> = {
  fotos: 'ri-image-line',
  videos: 'ri-movie-line',
  audios: 'ri-music-line',
  lives: 'ri-live-line',
};

export const fileTypeColors: Record<FileType, string> = {
  fotos: 'bg-amber-100 text-amber-700',
  videos: 'bg-rose-100 text-rose-700',
  audios: 'bg-emerald-100 text-emerald-700',
  lives: 'bg-violet-100 text-violet-700',
};

export const storageFiles: StorageFile[] = [
  // Fotos
  {
    id: 1,
    name: 'cabina-en-vivo-marzo.jpg',
    type: 'fotos',
    sizeMB: 2.1,
    sizeDisplay: '2.1 MB',
    uploadedAt: '2026-06-07T18:30:00Z',
    dimensions: '1920x1080',
    isPesado: false,
  },
  {
    id: 2,
    name: 'locutores-equipo-2026.jpg',
    type: 'fotos',
    sizeMB: 3.8,
    sizeDisplay: '3.8 MB',
    uploadedAt: '2026-06-05T10:15:00Z',
    dimensions: '2400x1600',
    isPesado: false,
  },
  {
    id: 3,
    name: 'evento-aniversario-5.jpg',
    type: 'fotos',
    sizeMB: 4.5,
    sizeDisplay: '4.5 MB',
    uploadedAt: '2026-05-28T21:00:00Z',
    dimensions: '3000x2000',
    isPesado: false,
  },
  {
    id: 4,
    name: 'logo-radio-nuevo.png',
    type: 'fotos',
    sizeMB: 0.8,
    sizeDisplay: '0.8 MB',
    uploadedAt: '2026-06-01T08:00:00Z',
    dimensions: '512x512',
    isPesado: false,
  },
  {
    id: 5,
    name: 'banner-promo-verano.jpg',
    type: 'fotos',
    sizeMB: 1.2,
    sizeDisplay: '1.2 MB',
    uploadedAt: '2026-05-20T14:45:00Z',
    dimensions: '1600x400',
    isPesado: false,
  },
  {
    id: 6,
    name: 'instagram-story-lunes.jpg',
    type: 'fotos',
    sizeMB: 0.5,
    sizeDisplay: '0.5 MB',
    uploadedAt: '2026-06-08T07:30:00Z',
    dimensions: '1080x1920',
    isPesado: false,
  },
  {
    id: 7,
    name: 'backstage-grabacion.jpg',
    type: 'fotos',
    sizeMB: 5.2,
    sizeDisplay: '5.2 MB',
    uploadedAt: '2026-06-03T16:20:00Z',
    dimensions: '4000x3000',
    isPesado: false,
  },
  // Videos
  {
    id: 8,
    name: 'entrevista-locutor-estrella.mp4',
    type: 'videos',
    sizeMB: 245.0,
    sizeDisplay: '245 MB',
    uploadedAt: '2026-05-15T11:00:00Z',
    duration: '12:30',
    isPesado: true,
  },
  {
    id: 9,
    name: 'detras-de-escena-abril.mp4',
    type: 'videos',
    sizeMB: 180.5,
    sizeDisplay: '180.5 MB',
    uploadedAt: '2026-04-22T09:30:00Z',
    duration: '08:45',
    isPesado: true,
  },
  {
    id: 10,
    name: 'clip-promocional-30s.mp4',
    type: 'videos',
    sizeMB: 28.3,
    sizeDisplay: '28.3 MB',
    uploadedAt: '2026-06-02T13:10:00Z',
    duration: '00:30',
    isPesado: true,
  },
  {
    id: 11,
    name: 'saludo-oyentes-navidad.mp4',
    type: 'videos',
    sizeMB: 95.0,
    sizeDisplay: '95 MB',
    uploadedAt: '2025-12-24T19:00:00Z',
    duration: '04:15',
    isPesado: true,
  },
  // Audios
  {
    id: 12,
    name: 'podcast-episodio-42.mp3',
    type: 'audios',
    sizeMB: 68.0,
    sizeDisplay: '68 MB',
    uploadedAt: '2026-06-06T06:00:00Z',
    duration: '48:20',
    isPesado: false,
  },
  {
    id: 13,
    name: 'jingle-radio-nueva-actitud.mp3',
    type: 'audios',
    sizeMB: 1.5,
    sizeDisplay: '1.5 MB',
    uploadedAt: '2026-01-10T12:00:00Z',
    duration: '00:45',
    isPesado: false,
  },
  {
    id: 14,
    name: 'cuña-publicitaria-15s.mp3',
    type: 'audios',
    sizeMB: 0.9,
    sizeDisplay: '0.9 MB',
    uploadedAt: '2026-05-18T08:30:00Z',
    duration: '00:15',
    isPesado: false,
  },
  {
    id: 15,
    name: 'mezcla-sabado-noche.mp3',
    type: 'audios',
    sizeMB: 142.0,
    sizeDisplay: '142 MB',
    uploadedAt: '2026-06-04T22:00:00Z',
    duration: '1:02:15',
    isPesado: false,
  },
  {
    id: 16,
    name: 'entrevista-completa-artista.mp3',
    type: 'audios',
    sizeMB: 78.5,
    sizeDisplay: '78.5 MB',
    uploadedAt: '2026-05-30T15:00:00Z',
    duration: '55:10',
    isPesado: false,
  },
  // Lives
  {
    id: 17,
    name: 'live-viernes-especial.mp4',
    type: 'lives',
    sizeMB: 450.0,
    sizeDisplay: '450 MB',
    uploadedAt: '2026-06-05T20:00:00Z',
    duration: '1:45:00',
    isPesado: true,
  },
  {
    id: 18,
    name: 'live-lanzamiento-disco.mp4',
    type: 'lives',
    sizeMB: 320.0,
    sizeDisplay: '320 MB',
    uploadedAt: '2026-05-14T19:30:00Z',
    duration: '1:20:00',
    isPesado: true,
  },
];

export function getTotalStorageUsed(files: StorageFile[]): number {
  return files.reduce((sum, f) => sum + f.sizeMB, 0);
}

export function formatStorageGB(mb: number): string {
  return (mb / 1024).toFixed(2);
}